import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import CameraPermissionScreen from './components/CameraPermissionScreen';
import InspeccionForm from './components/InspeccionForm';
import CargaFotos from './components/CargaFotos';
import InspeccionData from './models/InspeccionData';

function App() {
  const [cameraStream, setCameraStream] = useState(null);
  const [fotosCapturadas, setFotosCapturadas] = useState({});
  const [formData, setFormData] = useState(new InspeccionData());
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Estado de cameraStream en App:', cameraStream);
    if (!cameraStream) {
      console.log('No hay stream, redirigiendo a /');
      navigate('/');
    }
    // Comentar el cleanup para depurar
    // return () => {
    //   if (cameraStream) {
    //     console.log('Deteniendo el stream en cleanup');
    //     cameraStream.getTracks().forEach(track => track.stop());
    //   }
    // };
  }, [cameraStream, navigate]);
  const updateFormData = (newData) => {
    setFormData((prev) => new InspeccionData({ ...prev, ...newData }));
  };

  return (
    <Routes>
      <Route
        path="/"
        element={<CameraPermissionScreen setCameraStream={setCameraStream} />}
      />
      <Route
        path="/form"
        element={<InspeccionForm cameraStream={cameraStream} formData={formData} setFormData={updateFormData} />}
      />
      <Route
        path="/carga-fotos"
        element={
          <CargaFotos
            cameraStream={cameraStream}
            fotosCapturadas={fotosCapturadas}
            setFotosCapturadas={setFotosCapturadas}
            formData={formData}
          />
        }
      />
    </Routes>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}